"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const css_1 = require("@emotion/css");
exports.default = {
    clearfix: (0, css_1.css)({
        overflow: 'auto',
        zoom: 1,
    }),
    hidden: (0, css_1.css)({
        display: 'none !important',
    }),
    left: (0, css_1.css)({
        float: 'left',
    }),
    rigth: (0, css_1.css)({
        float: 'right',
    }),
    button: (0, css_1.css)({
        border: 0,
        margin: 0,
        padding: 0,
        cursor: 'pointer',
        background: 'transparent',
    }),
};
